import React from 'react';
import { Result } from 'antd';
import useUser from "hooks/useUser";

const LoggedInGuard = (props) => {

  const { loggedOut, userData } = useUser();

  const { children, userMustBePremium = false } = props;

  const NotFound = () => {
    return (
      <Result 
        title="Unauthorised Access"
        subTitle="You must be logged in to view this page"
        status="warning" 
        />
    );
  }

  const UserMustBePremium = () => {
    return (
      <Result 
        title="Unauthorised Access"
        subTitle="You must be a premium user to access this page"
        status="warning" 
        />
    );
  }

  return (
    <>
      {loggedOut ? (
        <NotFound />
      ) : (
        <>
          {userMustBePremium && !userData?.isPremium ? (
            <UserMustBePremium />
          ) : (
            <>{children}</>
          )}
        </>
      )}
    </>
  )

}

export default LoggedInGuard;
